export const DraggableItemType = {
  ImageCard: "image_card",
} as const;

// eslint-disable-next-line
export type DraggableItemType =
  typeof DraggableItemType[keyof typeof DraggableItemType];
